// @flow
import React, { type Node } from 'react';
import { connect } from 'react-redux';
import { analytics, analyticsActions, Track, urlCatalog } from 'angieslist-app-platform';
import { Button, Modal } from 'angieslist-react-components';
import { compose, pure } from 'recompose';
import { withRouter } from 'react-router';
import { defaultProps } from '../../../../app/browser/analyticsDefaultProperties';
import welcomeModalAnalytics from './welcomeModalAnalytics';

type Props = {
    // component props
    spId: string,
    // Modal trigger
    onRequestHide: () => void,
    // withRouter
    router: {
      push: (string) => any
    },
    // Redux actions
    sendEnhancedTrackEvent: typeof analyticsActions.sendEnhancedTrackEvent,
  }

export class WelcomeModalComponent extends React.Component<Props> {
  componentDidMount() {
    // This mirrors how our analytics page events fire after a timeout
    setTimeout(() => {
      this.props.sendEnhancedTrackEvent({
        name: 'Modal Fired',
        properties: {
          ...defaultProps,
          activityLocation: 'SP : Home',
          modalName: 'SP : Welcome Modal',
        },
      });
    }, 1000);
  }

  props: Props;


  closeModalAndRedirect: (() => void) = () => {
    this.props.onRequestHide();
    this.props.router.push(`/app/welcome/${this.props.spId}`);
  }

  render(): Node {
    const { spId } = this.props;

    return (
      <Modal show title="Welcome to the Business Center!">
        <div className="modal-body">
          <p>
            We are happy to see your interest in growing your business through Angi Ads.
          </p>
          <p>
            Complete your profile so members can learn what your business is all about.
          </p>
          <p>
            Make sure your service area is complete so you are visible to members in all areas
            you service.
          </p>
          <p style={{ marginBottom: 0 }}>
            Any customer can use the link below to submit a review of your business directly on
            Angi.
          </p>
          <p>
            <a
              id="welcome-modal--purl"
              target="_blank"
              href={urlCatalog.visitor.writeReview(spId)}
            >
              {urlCatalog.visitor.writeReview(spId)}
            </a>
          </p>
          <p>
            Use your Message Center to track and regularly respond to communication from members.
          </p>
          <br />
          <p>
            If you have any questions, contact us at&nbsp;
            <a
              id="welcome-modal--contact-us"
              href={urlCatalog.global.businessCenterPhone()}
            >
              {urlCatalog.global.businessCenterPhoneText()}
            </a>
          </p>
        </div>
        <div className="modal-footer">
          <Track>
            <Button
              id="welcome-modal--ok-button"
              bsSize="small"
              bsStyle="primary-office"
              flat
              data-track-spid={spId}
              onClick={this.closeModalAndRedirect}
            >
              Got it
            </Button>
          </Track>
        </div>
      </Modal>);
  }
}
export default (compose(
  analytics({
    ruleset: welcomeModalAnalytics,
  }),
  connect(
    null,
    analyticsActions,
  ),
  withRouter,
  pure,
)(WelcomeModalComponent): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/WelcomeModal.js